import {FORMATS} from '@chatize-ui/constants/formats'

export const APP_ROUTES: any[] = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.module').then(r => r.HomeModule),
  },
  {
    path: 'chat-document',
    loadChildren: () => import('./features/chat-document/chat-document.module').then(r => r.ChatDocumentModule),
  },
  {
    path: 'chat-ext',
    loadChildren: () => import('./features/chat-ext/chat-ext.module').then(r => r.ChatExtModule),
    format: {
      items: FORMATS,
      getPath: ext => `chat-${ext}`,
    },
  },
  {
    path: 'chat-room',
    loadChildren: () => import('./features/chat-room/chat-room.module').then(r => r.ChatRoomModule),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
]
